import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-active-menu-icon",
  "use": "icon-active-menu-icon-usage",
  "viewBox": "0 0 6 30",
  "content": "<symbol viewBox=\"0 0 6 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-active-menu-icon\">\n  <path d=\"M0 0C3.31371 0 6 2.68629 6 6V24C6 27.3137 3.31371 30 0 30V0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol